<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <b-container>
    <div class="slideshow-container">
      <!-- Full-width images with number and caption text -->
      <div class="mySlides">
        <div class="row">
          <div class="col-md-4">
            <img class="imgleft erwin" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" height="400px" />
          </div>
          <div class="col-md-4">
            <div class="left">
              <div class="arrowleft"></div>
              <p>Bonjour !</p>
            </div>
            <div class="right">
              <p>Bienvenue !</p>
              <div class="arrowright"></div>
            </div>
            <div class="right">
              <p>Bonjour !</p>
              <div class="arrowright"></div>
            </div>
            <div class="left long">
              <div class="arrowleft"></div>
              <p>
                On vient vers vous, pour une histoire un peu folle. Notre ballon s'est sacrément abîmé, et nous
                recherchons des pièces pour le réparer ! Vous pouvez nous aider ?
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <img class="imgright abeilles" src="https://cdn.exploreve.fr/content/cluedo/Abeilles.svg" height="400px" />
          </div>
        </div>
      </div>

      <div class="mySlides">
        <div class="row">
          <div class="col-md-4">
            <img class="imgleft" src="https://cdn.exploreve.fr/content/personnages/daria.svg" height="400px" />
          </div>
          <div class="col-md-4">
            <div class="right">
              <p>Vous tombez bien ! On a construit une montgolfière spécialement pour le jamborée !</p>
              <div class="arrowright"></div>
            </div>
            <div class="right">
              <p>On est venu de Montargis jusqu'ici avec !</p>
              <div class="arrowright"></div>
            </div>
            <div class="left">
              <div class="arrowleft"></div>
              <p>Quel exploit !</p>
            </div>
          </div>
          <div class="col-md-4">
            <img class="imgright abeilles" src="https://cdn.exploreve.fr/content/cluedo/Abeilles.svg" height="400px" />
          </div>
        </div>
      </div>

      <div class="mySlides">
        <div class="row">
          <div class="col-md-4">
            <img class="imgleft" src="https://cdn.exploreve.fr/content/personnages/daria.svg" height="400px" />
          </div>
          <div class="col-md-4">
            <div class="left">
              <div class="arrowleft"></div>
              <p>Quel exploit !</p>
            </div>
            <div class="right">
              <p>
                Justement, tu ne crois pas si bien dire ! C'est un véritable Exploit, vu qu'il s'agit d'une réalisation
                collective d'envergure, qui sort de l'ordinaire, et à laquelle on a tous participé, du plus petit au
                plus grand. Comme l'avait imaginé Baden-Powell !
              </p>
              <div class="arrowright"></div>
            </div>
            <div class="left long">
              <div class="arrowleft"></div>
              <p>
                Attendez, vous avez le droit de faire ça ? Genre construire des montgolfières et ce genre de trucs ?
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <img class="imgright abeilles" src="https://cdn.exploreve.fr/content/cluedo/Abeilles.svg" height="400px" />
          </div>
        </div>
      </div>

      <div class="mySlides">
        <div class="row">
          <div class="col-md-4">
            <img class="imgleft erwin" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" height="400px" />
          </div>
          <div class="col-md-4">
            <div class="right">
              <p>
                Bien sûr, toutes les patrouilles françaises doivent réaliser un Exploit pour venir ici ! Nous, on a même
                participé au Grand Exploit !
              </p>
              <div class="arrowright"></div>
            </div>
            <div class="left">
              <div class="arrowleft"></div>
              <p>C'est quoi le Grand Exploit ?</p>
            </div>
            <div class="right">
              <p>C’est un exploit particulièrement exceptionnel.</p>
              <div class="arrowright"></div>
            </div>
          </div>
          <div class="col-md-4">
            <img class="imgright abeilles" src="https://cdn.exploreve.fr/content/cluedo/Abeilles.svg" height="400px" />
          </div>
        </div>
      </div>

      <div class="mySlides">
        <div class="row">
          <div class="col-md-4">
            <img class="imgleft" src="https://cdn.exploreve.fr/content/personnages/daria.svg" height="400px" />
          </div>
          <div class="col-md-4">
            <div class="right">
              <p>
                Il y a une patrouille, venant de Melun, qui a réalisé un pont de singe de plus de 40m au dessus de la
                Seine !!
              </p>
              <div class="arrowright"></div>
            </div>
            <div class="right">
              <p>Et même la patrouille de Cavaillon qui a gravi un sommet les yeux bandés !</p>
              <div class="arrowright"></div>
            </div>
            <div class="left">
              <div class="arrowleft"></div>
              <p>Oh, imagine Erwin, si on faisait ça aujourd'hui ?</p>
            </div>
          </div>
          <div class="col-md-4">
            <img class="imgright abeilles" src="https://cdn.exploreve.fr/content/cluedo/Abeilles.svg" height="400px" />
          </div>
        </div>
      </div>

      <div class="mySlides">
        <div class="row">
          <div class="col-md-4">
            <img class="imgleft erwin" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" height="400px" />
          </div>
          <div class="col-md-4">
            <div class="left">
              <div class="arrowleft"></div>
              <p>Non je n'imagine pas !</p>
            </div>
            <div class="right">
              <p>Bon, trêve de plaisanteries les ami·es ! De quoi avez-vous besoin ?</p>
              <div class="arrowright"></div>
            </div>
            <div class="left">
              <div class="arrowleft"></div>
              <p>Hum. Un sextant, de la corde… Un brûleur !</p>
            </div>
          </div>
          <div class="col-md-4">
            <img class="imgright abeilles" src="https://cdn.exploreve.fr/content/cluedo/Abeilles.svg" height="400px" />
          </div>
        </div>
      </div>

      <div class="mySlides">
        <div class="row">
          <div class="col-md-4">
            <img class="imgleft erwin" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" height="400px" />
          </div>
          <div class="col-md-4">
            <div class="right">
              <p>Oh oui, on a un brûleur cassé qu’on peut vous donner.</p>
              <div class="arrowright"></div>
            </div>
            <div class="right">
              <p>
                Il n'est vraiment pas en bon état mais quelqu'un qui travaille dans la mécanique pourra vous aider !
              </p>
              <div class="arrowright"></div>
            </div>
            <div class="left">
              <div class="arrowleft"></div>
              <p>Merci beaucoup ! Promis, on en fera bon usage !</p>
            </div>

            <div class="right">
              Pas de soucis, ça fait plaisir de rendre service ! À bientôt !
              <div class="arrowright"></div>
            </div>
            <div @click="get_obj" class="object">Récupérer le brûleur.</div>
          </div>
          <div class="col-md-4">
            <img class="imgright abeilles" src="https://cdn.exploreve.fr/content/cluedo/Abeilles.svg" height="400px" />
          </div>
        </div>
      </div>

      <div class="mySlides">
        <div style="text-align: center;">
          <img src="https://cdn.exploreve.fr/content/cluedo/Bruleur.svg" height="400px" />
        </div>
      </div>
    </div>

    <!-- The dots/circles -->
    <div style="text-align: center;">
      <a class="prev" v-on:click="plusSlides(-1)">&#10094;</a>
      <span class="dot" v-on:click="currentSlide(1)"></span>
      <span class="dot" v-on:click="currentSlide(2)"></span>
      <span class="dot" v-on:click="currentSlide(3)"></span>
      <span class="dot" v-on:click="currentSlide(4)"></span>
      <span class="dot" v-on:click="currentSlide(5)"></span>
      <span class="dot" v-on:click="currentSlide(6)"></span>
      <span class="dot" v-on:click="currentSlide(7)"></span>
      <a class="next" v-on:click="plusSlides(1)">&#10095;</a>
    </div>
  </b-container>
</template>

<script>
export default {
  data: function () {
    return {
      slideIndex: 1
    };
  },
  mounted() {
    this.currentSlide(1);
  },
  methods: {
    get_obj() {
      this.$emit("recupObject", "bruleur");
      this.plusSlides(1);
    },

    plusSlides(n) {
      this.slideIndex += n;
      this.showSlides();
    },

    currentSlide(n) {
      if (this.slideIndex < n) return;
      this.slideIndex = n;
      this.showSlides();
    },

    showSlides() {
      var slides = document.getElementsByClassName("mySlides");
      var dots = document.getElementsByClassName("dot");
      if (this.slideIndex > slides.length) {
        this.slideIndex = 1;
      }
      if (this.slideIndex < 1) {
        this.slideIndex = slides.length;
      }
      for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      if (this.slideIndex < 8) {
        for (let i = 0; i < dots.length; i++) {
          dots[i].className = dots[i].className.replace(" active", "");
        }
        dots[this.slideIndex - 1].className += " active";
      }
      slides[this.slideIndex - 1].style.display = "block";
    }
  },
  components: {}
};
</script>

<style>
* {
  box-sizing: border-box;
}

.row {
  height: 100%;
}

.left,
.right {
  font-family: "Faune";
  display: table;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  margin: 20px;
  max-width: 300px;
  z-index: 5;
  width: intrinsic; /* Safari/WebKit utilisent un nom non-standard */
  width: -moz-max-content; /* Firefox/Gecko */
  width: -webkit-max-content;
}

.left {
  padding-left: 0px;
  margin-left: 20px;
  margin-right: auto;
}

.right {
  padding-right: 0px;
  margin-right: 10px;
  margin-left: auto;
}

p {
  display: table-cell;
  vertical-align: middle;
}

.long {
  max-width: 300px !important;
}

.arrowleft {
  position: relative;
  content: "";
  left: -20px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 20px solid white;
  z-index: 5;
}

.arrowright {
  position: relative;
  content: "";
  left: 20px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;

  border-left: 20px solid white;
}

.slideshow-container {
  width: auto;
  height: 500px;
  position: relative;
  margin: auto;
}

/* Hide the images by default */
.mySlides {
  display: none;
  height: 500px;
}

.imgleft {
  margin-left: 80px;
  position: absolute;
  top: 50%; /* poussé de la moitié de hauteur du référent */
  transform: translateY(-50%);
}

.imgright {
  margin-right: 100px;
  position: absolute;
  z-index: 1;
  top: 50%; /* poussé de la moitié de hauteur du référent */
  transform: translateY(-50%);
}

.abeilles {
  margin-right: -50px;
}

.imgfinal {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.imgvert {
  display: table-cell; /* comportement visuel de cellule */
  vertical-align: middle;
}

/* Next & previous buttons */
.prev,
.next {
  cursor: pointer;
  width: 20px;
  height: 20px;
  padding: 10px;
  margin: 10px;
  color: white !important;
  font-weight: bold;
  font-size: 18px;
  background-color: #cb8c31;
  transition: 0.6s ease;
  border-radius: 3px;
  user-select: none;
  top: 5px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover,
.next:hover {
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
}

.erwin {
  position: relative;
  left: 100px;
}

/* Caption text */
.text {
  color: #f2f2f2;
  font-size: 15px;
  padding: 8px 12px;
  position: absolute;
  bottom: 8px;
  width: 100%;
  text-align: center;
}

.object {
  font-family: "Faune";
  margin: auto;
  margin-top: 30px;
  text-align: center;
  padding: 5px 20px 5px 20px;
  width: intrinsic; /* Safari/WebKit utilisent un nom non-standard */
  width: -moz-max-content; /* Firefox/Gecko */
  width: -webkit-max-content;
  border-radius: 5px;
  background-color: #5e2a57;
  color: white;
  font-size: 26px;
  cursor: pointer;
}

/* The dots/bullets/indicators */
.dot {
  cursor: pointer;
  height: 8px;
  width: 8px;
  margin: 0 5px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.active,
.dot:hover {
  background-color: #717171;
}
</style>
